import { Component, OnInit } from '@angular/core';

import { faLockAlt } from '@fortawesome/pro-solid-svg-icons';

import { NavigationService } from '../../core/services/navigation.service';

@Component({
  selector: 'dx-page-access-denied',
  templateUrl: './page-access-denied.component.html',
  styleUrls: ['./page-access-denied.component.scss']
})
export class PageAccessDeniedComponent implements OnInit {
  faLockAlt = faLockAlt;

  constructor(private navigationService: NavigationService) { }

  get goBackUrlPath() {
    return this.navigationService.previousUrlPath;
  }

  get goBackUrlParams() {
    return this.navigationService.previousUrlParams;
  }

  get goBackName() {
    return this.navigationService.previousTitle;
  }

  ngOnInit() {
  }
}
